import Swiper, { Navigation, Pagination } from 'swiper';

// Loop mode clones slides, which would repeat the hero's H1
const demoteDuplicateHeadings = (wrapper) => {
    wrapper.querySelectorAll('.swiper-slide-duplicate h1').forEach((h1) => {
        const div = document.createElement('div');
        div.className = h1.className;
        div.innerHTML = h1.innerHTML;
        h1.replaceWith(div);
    });
};

export const initHomePageSlider = () => {
    const container = document.querySelector('.hero-slider .swiper-container');
    if (!container) {
        return;
    }

    const slider = new Swiper(container, {
        modules: [Navigation, Pagination],
        autoplay: {
            delay: 5000,
        },
        speed: 400,
        // A single slide has nothing to loop, and looping would only clone it
        loop: container.querySelectorAll('.swiper-slide').length > 1,
        effect: 'fade',
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        paginationClickable: true,
        grabCursor: true,
        navigation: {
            nextEl: '.hero-slider__nav-button--next',
            prevEl: '.hero-slider__nav-button--prev',
        },
    });

    demoteDuplicateHeadings(slider.wrapperEl);
    // Clones are rebuilt when the loop is fixed or re-created
    new MutationObserver(() => demoteDuplicateHeadings(slider.wrapperEl))
        .observe(slider.wrapperEl, { childList: true });
};

export const initEmployeeSlider = () => {

    const swiper = new Swiper('.swiper', {
        modules: [Navigation],
        // Optional parameters
        //direction: 'vertical',
        loop: true,

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

    });
};

export const initHeroSlider = () => {


};

export const initGalleryElementCarousel1 = () => {
	document.querySelectorAll('.js-gallery-element-carousel1').forEach(function (carousel) {
		new Swiper(carousel, {
			speed: 400,
			slidesPerView: 1,
			nextButton: carousel.parentNode.querySelector('.js-gallery-element-carousel1-next'),
			prevButton: carousel.parentNode.querySelector('.js-gallery-element-carousel1-prev'),
		});
	});
};

export const initGalleryElementCarousel2 = () => {
	document.querySelectorAll('.js-gallery-element-carousel2').forEach(function (carousel) {
		new Swiper(carousel, {
			speed: 400,
			spaceBetween: 8,
			slidesPerView: 2,
			nextButton: carousel.parentNode.querySelector('.js-gallery-element-carousel2-next'),
			prevButton: carousel.parentNode.querySelector('.js-gallery-element-carousel2-prev'),
			breakpoints: {
				639: {
					slidesPerView: 3
				},
				1023: {
					slidesPerView: 4
				}
			}
		});
	});
};
